import React, { useContext } from 'react';
import { Button, Col, Form, InputGroup, Modal, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import AppContext, { ProductContext } from 'context/Context';
import { Trans } from 'react-i18next';
import useAddressHook from 'y4/hooks/useAddressHook';

const AddressModal = () => {
  const {
    config: { isDark }
  } = useContext(AppContext);

  const {
    productsState: {
      addressModal: { show, address, type }
    },
    productsDispatch
  } = useContext(ProductContext);

  const { saveAddress, handleAddressChanged } = useAddressHook();

  const handleClose = () => {
    productsDispatch({
      type: 'TOGGLE_ADDRESS_MODAL'
    });
  };
  const handleSave = () => {
    saveAddress(address, type);
  };
  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header
        closeButton
        closeVariant={isDark ? 'white' : null}
        className="border-200"
      >
        <Modal.Title as="h5">
          <Flex alignItems="center">
            <div className="icon-item bg-soft-success shadow-none">
              <FontAwesomeIcon icon="map-marker-alt" className="text-success" />
            </div>
            <div className="ms-2">
              <Trans ns="commerce">
                {type === 'add' ? 'Add' : 'Edit'} shipping address
              </Trans>
            </div>
          </Flex>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="g-3 align-items-center">
          <Col md={6}>
            <InputGroup>
              <InputGroup.Text id="basic-addon1">
                <Trans ns="commerce">Username</Trans>
              </InputGroup.Text>
              <Form.Control
                placeholder=""
                aria-describedby="basic-addon1"
                value={address.name}
                onChange={e =>
                  handleAddressChanged({
                    name: e.target.value
                  })
                }
              />
            </InputGroup>
          </Col>
          <Col md={6}>
            <InputGroup>
              <InputGroup.Text id="basic-addon1">
                <Trans ns="commerce">Phone</Trans>
              </InputGroup.Text>
              <Form.Control
                placeholder=""
                aria-describedby="basic-addon1"
                value={address.phone}
                onChange={e =>
                  handleAddressChanged({
                    phone: e.target.value
                  })
                }
              />
            </InputGroup>
          </Col>
          <Col sm={12}>
            <InputGroup>
              <InputGroup.Text id="basic-addon1">
                <Trans ns="commerce">Street</Trans>
              </InputGroup.Text>
              <Form.Control
                placeholder=""
                aria-describedby="basic-addon1"
                value={address.street}
                onChange={e =>
                  handleAddressChanged({
                    street: e.target.value
                  })
                }
              />
            </InputGroup>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className="border-200">
        <IconButton
          as={Button}
          size="sm"
          className="ms-2"
          icon="save"
          variant="primary"
          iconAlign="left"
          onClick={handleSave}
        >
          <Trans ns="commerce">Save</Trans>
        </IconButton>
      </Modal.Footer>
    </Modal>
  );
};

export default AddressModal;
